module.exports = __webpack_public_path__ + "static/media/main idea.4d57e8bf.mp3";